import { Link } from 'react-router';

import { Button } from '@/components/shared/Button';
import { appRoutes } from '@/routes/app-routes.ts';
import { useChosenNumberStore, useModalStore } from '@/store';
import { formatNumberToStr } from '@/utils';

import cn from './styles.module.sass';
import { useYMOnMount } from '@/hooks';

export const SuccessfulPurchaseContent = () => {
    const { chosenNumber, deliveryMethod } = useChosenNumberStore();
    const { setIsPurchaseSuccessOpen } = useModalStore();

    useYMOnMount('successful_payment')

    return (
        <div className={cn.container}>
            <img src="/images/main/success_purchase.svg" alt="" />
            <div className={cn.head}>
                <h2>
                    Поздравляем
                    <br /> с приобретением номера!
                </h2>
                {chosenNumber?.number ||
                    (localStorage.getItem('preliminaryReservedMsisdn') && (
                        <div className={cn.numberHead}>
                            {chosenNumber?.number ||
                                formatNumberToStr(
                                    Number(localStorage.getItem('preliminaryReservedMsisdn'))
                                )}
                        </div>
                    ))}
            </div>
            <div className={cn.whatsNext}>
                <h3>Что делать дальше?</h3>
                <div className={cn.text}>
                    <p>
                        {deliveryMethod === 'by-courier' && 'Ожидай телефон курьера в смс'}
                        {deliveryMethod === 'by-mail' &&
                            'Ожидай трек-номер для отслеживания Почты России'}
                        {deliveryMethod === 'esim' &&
                            'На указанную почту придет письмо с QR-кодом.'}
                    </p>
                    <p>
                        {deliveryMethod === 'esim'
                            ? 'Отсканируй его телефоном, на котором планируешь пользоваться номером.'
                            : 'Если номер не включится автоматически, позвони'}
                    </p>
                    {deliveryMethod !== 'esim' && <p className={cn.number}>+7 (495) 221-73-43</p>}
                    <p>
                        {deliveryMethod === 'esim'
                            ? 'Следуй инструкциям на экране.'
                            : 'Мы пришлем этот номер в смс, но на всякий случай сделай скриншот этого экрана'}
                    </p>
                </div>
            </div>
            <Link
                to={appRoutes.myNumbers}
                onClick={() => {
                    setIsPurchaseSuccessOpen(false);
                    localStorage.removeItem('preliminaryReservedMsisdn');
                }}
            >
                <Button>Перейти в Мои номера</Button>
            </Link>
        </div>
    );
};
